import React from 'react';

// Spacer component for adding consistent spacing
const SpacerComponent = ({ 
  height = '32px',
  backgroundColor = 'transparent',
  showBorder = false
}) => {
  return (
    <div
      style={{
        height: height,
        backgroundColor: backgroundColor,
        borderTop: showBorder ? '1px solid #e2e8f0' : 'none',
        width: '100%'
      }}
    />
  );
};

export const Spacer = {
  fields: {
    height: {
      type: 'select',
      label: 'Höhe',
      options: [
        { label: 'Sehr klein (8px)', value: '8px' },
        { label: 'Klein (16px)', value: '16px' },
        { label: 'Mittel (32px)', value: '32px' },
        { label: 'Groß (48px)', value: '48px' },
        { label: 'Sehr groß (64px)', value: '64px' },
        { label: 'Extra groß (96px)', value: '96px' }
      ]
    },
    backgroundColor: {
      type: 'select',
      label: 'Hintergrundfarbe',
      options: [
        { label: 'Transparent', value: 'transparent' },
        { label: 'Weiß', value: '#ffffff' },
        { label: 'Grau (Hell)', value: '#f8fafc' },
        { label: 'Grau (Mittel)', value: '#e2e8f0' },
        { label: 'Grau (Dunkel)', value: '#475569' }
      ]
    },
    showBorder: {
      type: 'radio',
      label: 'Oberen Rand anzeigen',
      options: [
        { label: 'Ja', value: 'true' },
        { label: 'Nein', value: 'false' }
      ]
    }
  },
  render: SpacerComponent
};
